import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ScrollRedirect = ({ targetId }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });

    const scrollToTarget = () => {
      const el = document.getElementById(targetId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    // Delay to allow the DOM to mount Home component
    setTimeout(scrollToTarget, 100);
  }, [navigate, targetId]);

  return null;
};

export default ScrollRedirect;
